import * as Immutable from "immutable";
import ParameterBinding from "views/logic/parameters/ParameterBinding";
import ValueParameter from "views/logic/parameters/ValueParameter";
import StringUtils from "util/StringUtils";
const createParametersFromNames = (parameterNames) => Immutable.Map(
  parameterNames.map((name) => [
    name,
    ValueParameter.create(
      name,
      StringUtils.capitalizeFirstLetter(name),
      "",
      "string",
      void 0,
      false,
      ParameterBinding.empty()
    )
  ])
);
export default createParametersFromNames;
